/* ============================================================
   Wav Monopoly — collection card re-pricing.
   The preset cards default their DAW dropdown to the WMA
   (half-off) variant when it exists, so the shown price always
   agrees with the selected software. Changing the dropdown
   re-prices the card (amount + compare-at strike) and toggles
   the "with WMA plugin" cue. Prices come pre-formatted from
   Liquid (data-price-display / data-compare-display), so there
   is no money formatting here and currency stays correct.
   ============================================================ */
(function () {
  'use strict';

  function initCard(card) {
    var sel = card.querySelector('[data-pcard-daw]');
    var priceEl = card.querySelector('[data-pcard-price]');
    var amountEl = card.querySelector('[data-pcard-amount]');
    var wasEl = card.querySelector('[data-pcard-was]');
    var hintEl = card.querySelector('[data-pcard-wma-hint]');
    if (!sel || !amountEl) return;

    function update() {
      if (sel._wmSyncPicker) sel._wmSyncPicker();
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var addButton = card.querySelector('[name="add"]');
      if (addButton) addButton.disabled = opt.disabled;
      var priceDisplay = opt.getAttribute('data-price-display');
      var compareDisplay = opt.getAttribute('data-compare-display');
      var price = parseInt(opt.getAttribute('data-price'), 10);
      var compare = parseInt(opt.getAttribute('data-compare'), 10) || 0;
      var isWma = opt.getAttribute('data-wma') === 'true';
      var onSale = !isNaN(price) && compare > price;

      if (priceDisplay) amountEl.textContent = priceDisplay;
      if (priceEl) priceEl.classList.toggle('is-sale', onSale);
      if (wasEl) {
        wasEl.hidden = !onSale;
        if (onSale && compareDisplay) wasEl.textContent = compareDisplay;
      }
      if (hintEl) hintEl.hidden = !isWma;
    }

    sel.addEventListener('change', update);
    update();
  }

  function boot() {
    document.querySelectorAll('[data-pcard]').forEach(initCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
